export default __webpack_public_path__ + "static/media/arrow-down.12d25c2b.svg";